module.exports = __webpack_public_path__ + "static/media/video_icon.6e352699.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/assets/images/video_icon.png
// module id = 335
// module chunks = 29